export const ANONYMOUS_GENERATION_USAGE_STORAGE_KEY =
  "lettucetalk.anonymousGenerationUsage";

function getStorage() {
  try {
    if (typeof window === "undefined") {
      return null;
    }

    return window.sessionStorage || null;
  } catch (error) {
    return null;
  }
}

function getAnonymousUid(user) {
  return user?.isAnonymous === true && typeof user.uid === "string"
    ? user.uid.trim()
    : "";
}

function readUsageByUid(storage) {
  try {
    const storedUsage = storage.getItem(ANONYMOUS_GENERATION_USAGE_STORAGE_KEY);

    if (!storedUsage) {
      return {};
    }

    const parsedUsage = JSON.parse(storedUsage);

    return parsedUsage &&
      typeof parsedUsage === "object" &&
      !Array.isArray(parsedUsage)
      ? parsedUsage
      : {};
  } catch (error) {
    return {};
  }
}

export function markAnonymousGenerationUsed(user) {
  const uid = getAnonymousUid(user);
  const storage = getStorage();

  if (!uid || !storage) {
    return false;
  }

  try {
    const usageByUid = readUsageByUid(storage);

    storage.setItem(
      ANONYMOUS_GENERATION_USAGE_STORAGE_KEY,
      JSON.stringify({
        ...usageByUid,
        [uid]: Date.now(),
      })
    );

    return true;
  } catch (error) {
    return false;
  }
}

export function hasAnonymousGenerationBeenUsed(user) {
  const uid = getAnonymousUid(user);
  const storage = getStorage();

  if (!uid || !storage) {
    return false;
  }

  const usageByUid = readUsageByUid(storage);

  return Boolean(usageByUid[uid]);
}
